import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

function KelolaBanner({ setToken }) {
  const [banner, setBanner] = useState([]);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertJudul, setJudul] = useState(false);
  const [alertLink, setLink] = useState(false);
  const [alertThumbnail, setAlertThumbnail] = useState(false);
  const [formData, setFormData] = useState({
    judul: "",
    link: "",
    thumbnail: null,
    created_date: "",
  });
  const [id, setId] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      await fetch(BaseURL + "index.php/api/Banner")
        .then((res) => res.json())
        .then((data) => {
          setBanner(data.data);
          setLoading(false);
        });
    };
    getData();
  }, [load]);

  useEffect(() => {
    let tablesData = [];

    if (banner.length > 0) {
      for (let i = 0; i < banner.length; i++) {
        tablesData.push({
          judul: banner[i].judul,
          link: banner[i].link,
          tanggal_post: banner[i].created_date,
          thumbnail: banner[i].thumbnail,
          opsi: banner[i].id_banner,
        });
      }
    }
    setTableData(tablesData);
  }, [banner]);

  const columns = [
    {
      name: "judul",
      label: "Judul",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ width: 200 }}>{value}</div>;
        },
      },
    },
    {
      name: "link",
      label: "Link",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "thumbnail",
      label: "thumbnail",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <img src={BaseURL + "assets/images/banner/" + value} style={{ width: 150, objectFit: "contain" }}></img>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: "none",
  };

  const tambah = () => {
    if (formData.judul == "") {
      setJudul(true);
    } else {
      setJudul(false);
    }

    if (formData.link == "") {
      setLink(true);
    } else {
      setLink(false);
    }

    if (formData.thumbnail == null) {
      setAlertThumbnail(true);
    } else {
      setAlertThumbnail(false);
    }

    if (formData.judul !== "" && formData.link !== "" && formData.thumbnail !== null) {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "post");
      data.append("judul", formData.judul);
      data.append("link", formData.link);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);
      data.append("image", formData.thumbnail);

      try {
        fetch(BaseURL + "index.php/api/Banner", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              link: "",
              thumbnail: null,
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = ($id) => {
    try {
      fetch(BaseURL + "index.php/api/Banner/" + $id, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = ($id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/Banner?id=" + $id)
        .then((res) => res.json())
        .then((data) => {
          let createdDate = data.data[0].created_date.split(" ");
          let m = "";
          switch (createdDate[1]) {
            case "Januari":
              m = "1";
              break;
            case "Februari":
              m = "2";
              break;
            case "Maret":
              m = "3";
              break;
            case "April":
              m = "4";
              break;
            case "Mei":
              m = "5";
              break;
            case "Juni":
              m = "6";
              break;
            case "Juli":
              m = "7";
            case "Agustus":
              m = "8";
            case "September":
              m = "9";
            case "Oktober":
              m = "10";
            case "November":
              m = "11";
            case "Desember":
              m = "12";
          }
          createdDate = createdDate[2] + "-" + m + "-" + createdDate[0];
          setFormData({
            ...formData,
            judul: data.data[0].judul,
            link: data.data[0].link,
            created_date: createdDate,
          });
          setId($id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.judul == "") {
      setJudul(true);
    } else {
      setJudul(false);
    }

    if (formData.link == "") {
      setLink(true);
    } else {
      setLink(false);
    }

    if (formData.judul !== "" && formData.link !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "put");
      data.append("id_banner", id);
      data.append("judul", formData.judul);
      data.append("link", formData.link);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", formData.created_date);
      data.append("updated_date", date);
      data.append("image", formData.thumbnail);

      try {
        fetch(BaseURL + "index.php/api/Banner", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              link: "",
              thumbnail: null,
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola Banner" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable title={"Daftar Banner"} data={tableData} columns={columns} options={options} download={false} className="table" />
          )}
        </div>
      </div>

      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField id="judul" label="Judul" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, judul: e.target.value })} value={formData.judul} />
            {alertJudul && <div className="danger-alert">Judul tidak boleh kosong</div>}

            <TextField id="link" label="Link" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, link: e.target.value })} value={formData.link} />
            {alertLink && <div className="danger-alert">Link tidak boleh kosong</div>}

            <div style={{ height: 10 }}></div>

            <div className="btn-thumbnail">
              <Button title="Pilih thumbnail" type="secondary" />
              <span className="file-name">{formData.thumbnail != null ? formData.thumbnail.name : updateModal ? "(Jika tidak ingin mengubah thumbnail, tetap kosongkan)" : "(anda belum memilih gambar/thumbnail)"}</span>
              <input className="invisible-input" type="file" title="Pilih thumbnail" onChange={(e) => setFormData({ ...formData, thumbnail: e.target.files[0] })}></input>
            </div>
            {alertThumbnail && <div className="danger-alert">Thumbnail tidak boleh kosong</div>}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  judul: "",
                  link: "",
                  thumbnail: null,
                  created_date: "",
                });
                setJudul(false);
                setLink(false);
                setAlertThumbnail(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"}></i>
          {success ? <p>Berhasil</p> : <p className={success ? "" : "failed-pop-up"}>Gagal</p>}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setJudul(false);
              setLink(false);
              setAlertThumbnail(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaBanner;
